import { type SmartResizeRetrySuggestion } from './types';

export const SMART_RESIZE_RETRY_SUGGESTIONS = [
  { id: 'background', label: 'Background looks wrong' },
  { id: 'brand-or-instructions', label: 'Off-brand colors or fonts' },
  { id: 'logo', label: 'Logo cropped or moved' },
  { id: 'platform-ui', label: 'Hidden behind captions or buttons' },
  { id: 'text', label: 'Text changed' },
  { id: 'subject', label: 'Focused on the wrong thing' },
  { id: 'other-elements', label: 'Other elements changed' },
] as const satisfies readonly SmartResizeRetrySuggestion[];

export const SMART_RESIZE_RETRY_HELPER_TEXT = "Tap anything that's off and describe what should change";
